import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Button } from 'antd';
import { CheckOutlined, CloseOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { ChatMessage } from '../../types/aiChat';

interface AiChatMessageProps {
  message: ChatMessage;
  onConfirmAction?: (actionId: string) => void;
  onCancelAction?: (actionId: string) => void;
  /** True while a confirm/cancel request is in flight (disables the buttons). */
  actionBusy?: boolean;
}

const STATUS_LABELS: Record<string, string> = {
  confirmed: 'Confirmada',
  cancelled: 'Cancelada',
  failed: 'No se pudo ejecutar',
  expired: 'Expirada',
};

const AiChatMessage: React.FC<AiChatMessageProps> = ({
  message,
  onConfirmAction,
  onCancelAction,
  actionBusy,
}) => {
  const action = message.pendingAction;
  const status = message.pendingActionStatus;

  return (
    <div className={`ai-chat-message ${message.role}`}>
      <div className="ai-chat-bubble">
        {message.role === 'assistant' ? (
          <ReactMarkdown>{message.content}</ReactMarkdown>
        ) : (
          message.content
        )}
      </div>

      {action && (
        <div className={`ai-chat-action-card ${status === 'pending' ? 'is-pending' : 'is-resolved'}`}>
          <div className="ai-chat-action-title">
            <ThunderboltOutlined />
            {action.title}
          </div>
          {Object.entries(action.details).length > 0 && (
            <div className="ai-chat-action-details">
              {Object.entries(action.details).map(([label, value]) => (
                <div key={label} className="ai-chat-action-detail">
                  <span className="ai-chat-action-detail-label">{label}</span>
                  <span className="ai-chat-action-detail-value">{value}</span>
                </div>
              ))}
            </div>
          )}
          {status === 'pending' ? (
            <div className="ai-chat-action-buttons">
              <Button
                type="primary"
                size="small"
                icon={<CheckOutlined />}
                loading={actionBusy}
                onClick={() => onConfirmAction?.(action.id)}
              >
                Confirmar
              </Button>
              <Button
                size="small"
                icon={<CloseOutlined />}
                disabled={actionBusy}
                onClick={() => onCancelAction?.(action.id)}
              >
                Cancelar
              </Button>
            </div>
          ) : (
            <div className={`ai-chat-action-status ai-chat-action-status--${status}`}>
              {STATUS_LABELS[status ?? ''] ?? ''}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AiChatMessage;
